
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>EW User Limit Config Log</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">EW User Limit Config Log</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
        <div class="container-fluid">
          <div class="card" id="EWUserLimitConfigLog">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
                <div class="card-tools">
                  <router-link class="btn btn-info" :to="{name: 'EWUserLimitConfigLogList'}"><i class="fas fa-list"></i> List
                  </router-link>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                    <div class="col-8">
                    
                    
            <div class="form-group required" >
              <label class="control-label">Limit Config ID</label>
              <input type="text" id="limit_config_id" name="limit_config_id"
                     v-bind:class="{'has-error' : errors.has('limit_config_id')}"
                     v-validate="'required'"
                     v-model="value.limit_config_id" class="form-control limit_config_id"
                     placeholder="Limit Config ID">
              <div class="help text-danger" v-show="errors.has('limit_config_id')">
                {{ errors.first("limit_config_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">User ID</label>
              <input type="text" id="user_id" name="user_id"
                     v-bind:class="{'has-error' : errors.has('user_id')}"
                     v-validate="'required'"
                     v-model="value.user_id" class="form-control user_id"
                     placeholder="User ID">
              <div class="help text-danger" v-show="errors.has('user_id')">
                {{ errors.first("user_id") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Previous Data</label>
              <textarea id="previous_data" name="previous_data"
                 v-bind:class="{'has-error' : errors.has('previous_data')}"
                 v-validate="'required'"
                 v-model="value.previous_data" class="form-control previous_data"
                 placeholder="Previous Data"
                 rows="3"></textarea>
              <div class="help text-danger" v-show="errors.has('previous_data')">
                {{ errors.first("previous_data") }}
              </div>
            </div>
            <div class="form-group required" >
              <label class="control-label">Current Data</label>
              <textarea id="current_data" name="current_data"
                 v-bind:class="{'has-error' : errors.has('current_data')}"
                 v-validate="'required'"
                 v-model="value.current_data" class="form-control current_data"
                 placeholder="Current Data"
                 rows="3"></textarea>
              <div class="help text-danger" v-show="errors.has('current_data')">
                {{ errors.first("current_data") }}
              </div>
            </div>
                    </div>
                </div>
              </div>
              <div class="card-footer">
                <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
                <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
              </div>
            </form>
          </div>
        </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'

export default {
  name: 'EWUserLimitConfigLogForm',
  metaInfo: {
    title: 'EW User Limit Config Log | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    
    value: {
        
        
    },
    pre: {
      
    }
  }),
  methods: {
    
    
    
    handleSubmission () {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/ew_user_limit_config_logs'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/ew_user_limit_config_logs/' + _this.$route.params.id
            method = 'PUT'
          }
          
          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' },
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.$router.push({'name': 'EWUserLimitConfigLogList'})
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = '/ew_user_limit_config_logs/' + id
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params
      
      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data
        }).catch((error) => {
          console.log(error.response)
        })
        
        
      }
      
      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>

        